import { createAction, createSlice } from '@reduxjs/toolkit';
import { GET_PROJECTS_SUCCESS } from '../../constants/actions/project.constants';
import { LOGOUT } from '../../constants/actions/auth.constants';
import type { IProject } from '../../types';

const getProjectsSuccess = createAction<IProject[]>(GET_PROJECTS_SUCCESS);

const NAME = 'surveyProjects';

const slice = createSlice({
    name: NAME,
    initialState: [] as IProject[],
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProjectsSuccess, (_, action) => action.payload)
            .addCase(LOGOUT, () => []);
    },
});

export default { reducer: slice.reducer, actions: slice.actions };
